/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Encrypted_Lead_Signal_RecordInputs */

const en_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encrypted Lead Signal Record • End of Stack`)
};

const es_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro cifrado de señales de clientes • Fin de la pila`)
};

const fr_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement crypté des signaux de prospects • Fin de la pile`)
};

const de_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschlüsselter Lead-Signal-Datensatz • Ende des Stacks`)
};

const ja_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗号化されたリードシグナルレコード • スタックの終わり`)
};

const zh_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加密线索信号记录 • 堆栈结束`)
};

const ar_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل إشارات العملاء المشفر • نهاية المكدس`)
};

const id_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekaman Sinyal Prospek Terenkripsi • Ujung Stack`)
};

const it_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro Segnali Lead Crittografato • Fine dello Stack`)
};

const ru_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зашифрованная запись сигнала лида • Конец стека`)
};

const pt_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de Sinal de Lead Criptografado • Fim da Pilha`)
};

const ko_encrypted_lead_signal_record = /** @type {(inputs: Encrypted_Lead_Signal_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`암호화된 리드 시그널 기록 • 스택의 끝`)
};

/**
* | output |
* | --- |
* | "Encrypted Lead Signal Record • End of Stack" |
*
* @param {Encrypted_Lead_Signal_RecordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const encrypted_lead_signal_record = /** @type {((inputs?: Encrypted_Lead_Signal_RecordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Encrypted_Lead_Signal_RecordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_encrypted_lead_signal_record(inputs)
	if (locale === "es") return es_encrypted_lead_signal_record(inputs)
	if (locale === "fr") return fr_encrypted_lead_signal_record(inputs)
	if (locale === "de") return de_encrypted_lead_signal_record(inputs)
	if (locale === "ja") return ja_encrypted_lead_signal_record(inputs)
	if (locale === "zh") return zh_encrypted_lead_signal_record(inputs)
	if (locale === "ar") return ar_encrypted_lead_signal_record(inputs)
	if (locale === "id") return id_encrypted_lead_signal_record(inputs)
	if (locale === "it") return it_encrypted_lead_signal_record(inputs)
	if (locale === "ru") return ru_encrypted_lead_signal_record(inputs)
	if (locale === "pt") return pt_encrypted_lead_signal_record(inputs)
	return ko_encrypted_lead_signal_record(inputs)
});